export default __webpack_public_path__ + "static/media/cont3.a18fe386.png";